module.exports = __webpack_public_path__ + "img/1.6a78c543.png";